import { Link } from 'react-router';
import './view-transaction.css';
import { t } from 'i18next';

interface ViewTransactionProps {
  txUrl: string;
  title?: string;
}

export function ViewTransaction({ txUrl, title }: ViewTransactionProps) {
  return (
    <div>
      <p>{title}</p>
      <Link to={txUrl} target="_blank" className="text-xs text-white">
        <span className="text-[#808080]">{t('View')}</span> {t('transaction')}
      </Link>
    </div>
  );
}
